<template>
	<loading-indicator v-if="loading" class="my-5" />
	<validation-observer v-else v-bind="$attrs" ref="observer" v-slot="{ invalid }">
		<b-form @submit.prevent="save" >
			<b-card no-body>
				<slot name="header"></slot>

				
                <!--Main Section start-->
				<b-card-body>
					<b-row>
						<b-col md="6">
							<validation-provider
								vid="disp_name"
								name="display_name"
								:rules="{ required: true, max: 60 }"
								v-slot="validationContext"
							>
								<b-form-group label="Facility Name" label-for="disp_name" label-cols-lg="4">
									<b-form-input
										name="disp_name"
										type="text"
										v-model="entity.display_name"
										:state="getValidationState(validationContext)"
										required="required"
										
									/>
									<b-form-invalid-feedback
										v-for="error in validationContext.errors"
										:key="error"
										v-text="error"
									/>
								</b-form-group>
							</validation-provider>
						</b-col>
						<b-col md="6">
							<validation-provider
								vid="pri_name"
								name="prior_name"
								:rules="{ required: false, max: 60 }"
								v-slot="validationContext"
							>
								<b-form-group label="Prior Name" label-for="pri_name" label-cols-lg="4">
									<b-form-input
										name="pri_name"
										type="text"
										v-model="entity.prior_name"
										:state="getValidationState(validationContext)"
										
									/>
									<b-form-invalid-feedback
										v-for="error in validationContext.errors"
										:key="error"
										v-text="error"
									/>
								</b-form-group>
							</validation-provider>
						</b-col>
					</b-row>
					<div>
					<b-row>
					<!-- First Column -->
					<b-col md="6">
						<!-- Facility Type -->
						<validation-provider
						vid="facility_type_id"
						name="Facility Type"
						:rules="{ required: false }"
						v-slot="validationContext"
						>
						<b-form-group label="Facility Type" label-for="facility_type_id" label-cols-lg="4">
							<b-form-select
							name="facility_type_id"
							v-model="entity.facility_type_id"
							:state="getValidationState(validationContext)"
							:options="facilityTypes"
							:disabled="saving"
							value-field="id"
							text-field="name"
							/>
							<b-form-invalid-feedback
							v-for="error in validationContext.errors"
							:key="error"
							v-text="error"
							/>
						</b-form-group>
						</validation-provider>
					</b-col>

					<!-- Second Column -->
					<b-col md="6">
						<!-- Ownership Type -->
						<validation-provider
						vid="ownership_type"
						name="Ownership Type"
						:rules="{ required: false }"
						v-slot="validationContext"
						>
						<b-form-group label="Type of Ownership" label-for="ownership_type" label-cols-lg="4">
							<b-form-select
							name="ownership_type"
							v-model="contractDetails.ownership_type"
							:state="getValidationState(validationContext)"
							:options="ownershipTypes"
							:disabled="saving"
							value-field="value"
                            text-field="text"
							/>
							<b-form-invalid-feedback
							v-for="error in validationContext.errors"
							:key="error"
							v-text="error"
							/>
						</b-form-group>
						</validation-provider>
					</b-col>
					</b-row>
				</div>

					<b-row>
					<!-- First Column -->
					<b-col md="6">
						<!-- Address 1 -->
						<validation-provider vid="street_address_1" name="Street Address" :rules="{ required: false, max: 50 }" v-slot="validationContext">
						<b-form-group label="Address1" label-for="street_address_1" label-cols-lg="4">
							<b-form-input name="street_address_1" type="text" v-model="entity.address_2" placeholder="Street address" class="rounded-b-0" :state="getValidationState(validationContext)" :disabled="saving" />
							<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
						</b-form-group>
						</validation-provider>

						<!-- City -->
						<validation-provider vid="city" name="City" :rules="{ required: false, max: 50 }" v-slot="validationContext">
						<b-form-group label="City" label-for="city" label-cols-lg="4">
							<b-form-input name="city" type="text" v-model="entity.city" :state="getValidationState(validationContext)" :disabled="saving" />
							<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
						</b-form-group>
						</validation-provider>

						<!-- Zip -->
						<validation-provider vid="zip" name="Zip" :rules="{ required: false, max: 20, alpha_num: true }" v-slot="validationContext">
						<b-form-group label="Zip" label-for="zip" label-cols-lg="4">
							<b-form-input name="zip" type="text" v-model="entity.zip" :state="getValidationState(validationContext)" :disabled="saving" />
							<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
						</b-form-group>
						</validation-provider>

						<validation-provider
									vid="original_start_date"
									name="Original Start Date"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									<b-form-group label="Original Start Date" label-for="original_start_date" label-cols-lg="4">
										<b-form-input
										    :min="minDate"
                                            :max="today"
											type="date"
											v-model="contractDetails.original_start_date"
											name="original_start_date"
											:disabled="saving"
											:state="getValidationState(validationContext)"
											 @input="onOriginalStartDateChange"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider>

						<!-- Active -->
						

					<validation-provider vid="active" name="Active" :rules="{ required: false }" v-slot="validationContext">
						<b-form-group label="Facility Status" label-for="active" label-cols-lg="4">
							<b-form-select v-model="entity.facility_status" :options="facilityStatus" :disabled="saving"></b-form-select>
							<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
						</b-form-group>
					</validation-provider>


					<b-form-group label="LOB" label-for="bill_type" label-cols-lg="4">
							<b-form-select name="bill_type" v-model="entity.bill_type" :options="billTypeOptions" value-field="abbreviation" text-field="name" :disabled="saving">
								<!-- <template #first>
									<option :value="null" />
								</template> -->
							</b-form-select>
						</b-form-group>

						<b-form-group label="Chain" label-for="chain_name" label-cols-lg="4">
								<b-input-group>
									<b-form-input type="text" name="chain_name" v-model="entity.chain_name"
										:disabled="saving"
										placeholder="Search for a Chain..." @input="filterChains" />
								</b-input-group>
								<div class="mb-0" style="margin: 0;">
									<b-list-group v-if="filteredChains.length > 0">
										<b-list-group-item v-for="chain in filteredChains" :key="chain.id"
											@click="selectChain(chain)">
											{{ chain.chain_name }}
										</b-list-group-item>
									</b-list-group>
								</div>
						</b-form-group>


					
					</b-col>

					<!-- Second Column -->
					<b-col md="6">

						<!-- Address 2 -->
						<validation-provider vid="street_address_2" name="Street Address" :rules="{ required: false, max: 50 }" v-slot="validationContext">
						<b-form-group label="Address2" label-for="street_address_2" label-cols-lg="4">
							<b-form-input name="street_address_2" type="text" v-model="entity.street_address_2" placeholder="Suite, unit, floor, etc..." class="rounded-b-0" :state="getValidationState(validationContext)" :disabled="saving" />
							<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
						</b-form-group>
						</validation-provider>

						<!-- State -->
						<validation-provider vid="state" name="State" :rules="{ required: false, max: 2 }" v-slot="validationContext">
						<b-form-group label="State" label-for="state" label-cols-lg="4">
							<b-form-select name="state" v-model="entity.state" :options="states" value-field="abbreviation" text-field="name" :state="getValidationState(validationContext)" :disabled="saving">
							<template #first>
								<option :value="null" />
							</template>
							</b-form-select>
							<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
						</b-form-group>
						</validation-provider>

						<!-- County -->
						<validation-provider vid="county" name="County" :rules="{ required: false, max: 50 }" v-slot="validationContext">
						<b-form-group label="County" label-for="county" label-cols-lg="4">
							<b-form-input name="county" type="text" v-model="entity.county" :state="getValidationState(validationContext)" :disabled="saving" />
							<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
						</b-form-group>
						</validation-provider>

						<validation-provider
						vid="term_date"
						name="Term Date"
						:rules="{ required: false }"
						v-slot="validationContext"
						>
						<b-form-group label="Term Date" label-for="term_date" label-cols-lg="4">
							<b-form-input
							id="term_date"
							type="date"
							v-model="contractDetails.term_date"
							name="term_date"
							:disabled="!contractDetails.original_start_date || saving"
							:state="getValidationState(validationContext)"
							:style="{ color: entity.facility_status === 'Inactive' ? 'red' : 'inherit' }"
							:min="termMinDate"
							/>
							<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
						</b-form-group>
						</validation-provider>

						 <!-- Owned -->
						<validation-provider vid="client_owned" name="Owned" :rules="{ required: false }" v-slot="validationContext">
							<b-form-group label="Owned" label-for="client_owned" label-cols-lg="4" description="Facility is owned/provided by the client.">
							<b-form-checkbox name="client_owned" v-model="entity.client_owned" :disabled="saving">Owned</b-form-checkbox>
							<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
							</b-form-group>
						</validation-provider>

						<validation-provider
									vid="has_contract"
									name="Contract"
									:rules="{ required: false }"
									v-slot="validationContext"
						>
							<b-form-group
								label="Contract"
								label-for="has_contract"
								label-cols-lg="4"
								description="This facility is contracted."
								v-if="entity.has_contract"
							>
									<b-form-checkbox
										name="has_contract"
										v-model="entity.has_contract"
										:disabled="true"
										:state="getValidationState(validationContext)"
										v-if="entity.has_contract"
									>
										Has Contract
									</b-form-checkbox>
									<b-form-invalid-feedback
										v-for="error in validationContext.errors"
										:key="error"
										v-text="error"
									/>
							</b-form-group>
						</validation-provider>
						<!-- Duplicate  -->
						<validation-provider vid="is_duplicate" name="Duplicate" :rules="{ required: false }" v-slot="validationContext">
							<b-form-group label="Duplicate" label-for="is_duplicate" label-cols-lg="4" description="Check the box if this facility is a duplicate">
							<b-form-checkbox name="is_duplicate" v-model="entity.is_duplicate" :disabled="saving">Not to use</b-form-checkbox>
							<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
							</b-form-group>
						</validation-provider>

						

					</b-col>
					</b-row>

				</b-card-body>
				<!--Main section end-->

				<!-- Details section start-->
				<b-card no-body>
					
					<template v-if="entity.has_contract">
						<!-- Contract Section Start-->
						<b-card-header header-tag="header" role="tab" class="p-0">
							<b-button
								block
								v-b-toggle.collapseContract
								variant="light"
								role="tab"
								class="text-left px-4 py-3 m-0"
								>Contract</b-button
							>
						</b-card-header>
						<b-collapse id="collapseContract" role="tabpanel">
							<b-card-body>
							<b-row>
							<!-- First Column -->
							<b-col md="6">
								<validation-provider
									vid="active"
									name="Active"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									
									<b-form-group
										label="Contract Status"
										label-for="contractStatus"
										label-cols-lg="4"
									>
										<b-form-select
											id="contractStatus"
											v-model="contractDetails.contract_status"
											:options="contractStatusOptions"
											:disabled="saving"
											value-field="id"
											text-field="contract_status"
										></b-form-select>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>

								</validation-provider>

								<validation-provider
									vid="contract_end_date"
									name="Contract End Date"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									<b-form-group label="Expiration Date" label-for="contract_end_date" label-cols-lg="4">
										<b-form-input
											type="date"
											:min="contractDetails.contract_start_date"
											v-model="contractDetails.contract_end_date"
											name="contract_end_date"
											:disabled="saving"
											:state="getValidationState(validationContext)"
											:style="{ color: contractDetails.contract_status === 2 ? 'red' : contractDetails.contract_status === 3 ? '#FFD700' : 'inherit' }"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider>

								

							</b-col>

							<!-- Second Column -->
							<b-col md="6">
								<validation-provider
									vid="contract_start_date"
									name="Contract Start Date"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									<b-form-group label="Contract Effective Date" label-for="contract_start_date" label-cols-lg="4">
										<b-form-input
											type="date"
											:max="today"
											v-model="contractDetails.contract_start_date"
											name="contract_start_date"
											:disabled="saving"
											:state="getValidationState(validationContext)"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider>

								<validation-provider
									vid="renewal_date"
									name="Renewal Date"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									<b-form-group label="Renewal Date" label-for="renewal_date" label-cols-lg="4">
										<b-form-input
											type="date"
											:min="contractDetails.contract_start_date"
											v-model="contractDetails.renewal_date"
											name="renewal_date"
											:disabled="saving"
											:state="getValidationState(validationContext)"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider>

								</b-col>
								</b-row>

									<b-row>
									<!-- First Column -->
									<b-col md="6">
										<!-- Contract Bill Type -->
										<validation-provider
										vid="contract_bill_type"
										name="Contract Bill Type"
										:rules="{ required: false }"
										v-slot="validationContext"
										>
										<b-form-group label="Contract Bill Type" label-for="contract_bill_typee" label-cols-lg="4">
											<b-form-select
											name="contract_bill_type"
											v-model="contractDetails.contract_bill_type"
											:state="getValidationState(validationContext)"
											:options="contractBillTypes"
											 :disabled="true"
											value-field="id"
											text-field="billtype"
											:style="{ pointerEvents: readonly ? 'none' : 'auto', opacity: readonly ? '0.6' : '1' }"
											>
											
											</b-form-select>
											<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
											/>
										</b-form-group>
										</validation-provider>

										<validation-provider
										vid="indemnification_days"
										name="Indemnification Days"
										:rules="{ required: false, min: 0, max: 365 }"
										v-slot="validationContext"
									>
										<b-form-group
											label="Indemnification Days"
											label-for="indemnification_days"
											label-cols-lg="4"
											description="Days exceeded for Indemnification"
										>
											<b-form-input
												name="indemnification_days"
												type="number"
												step="1"
												min="0"
												max="365"
												v-model="contractDetails.indemnification_days"
												:disabled="saving"
												:state="getValidationState(validationContext)"
											/>
											<b-form-invalid-feedback
												v-for="error in validationContext.errors"
												:key="error"
												v-text="error"
											/>
										</b-form-group>
									</validation-provider>

									</b-col>

									<!-- Second Column -->
									<b-col md="6">
										<!-- Contract Type -->
										<validation-provider
										vid="contract_type"
										name="Contract Type"
										v-slot="validationContext"
										>
										<b-form-group label="Contract Type" label-for="contract_type" label-cols-lg="4">
											<b-form-select
											name="contract_type"
											v-model="contractDetails.contract_type"
											:state="getValidationState(validationContext)"
											:options="contractTypes"
											 :disabled="true"
											value-field="value"
											text-field="text"
											direction="down"
											/>
											<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
											/>
										</b-form-group>
										</validation-provider>

										<validation-provider
										vid="max_return_work_days"
										name="Max Return Days"
										:rules="{ required: false, min: 0, max: 365 }"
										v-slot="validationContext"
									>
										<b-form-group
											label="Max Return Days"
											label-for="max_return_work_days"
											label-cols-lg="4"
											description="Maximum days to return work to facility"
										>
											<b-form-input
												name="max_return_work_days"
												type="number"
												step="1"
												min="0"
												max="365"
												v-model="contractDetails.max_return_work_days"
												:disabled="saving"
												:state="getValidationState(validationContext)"
											/>
											<b-form-invalid-feedback
												v-for="error in validationContext.errors"
												:key="error"
												v-text="error"
											/>
										</b-form-group>
									</validation-provider>
									</b-col>
								</b-row>

								<!-- <validation-provider
								vid="service_operations"
								name="Service Operations"
								:rules="{ required: false }"
								v-slot="validationContext"
								>
								<b-form-group label="Service Operations" label-for="service_operations" label-cols-lg="2">
									<b-form-checkbox-group
									id="service_operations"
									v-model="contractDetails.serviceOperation"
									:options="serviceOperationsOptions"
									:state="getValidationState(validationContext)"
									:disabled="true"
									/>
									<b-form-invalid-feedback
									v-for="error in validationContext.errors"
									:key="error"
									v-text="error"
									/>
								</b-form-group>
								</validation-provider> -->

								<b-card title="Contract Pricing Schedule" border-variant="light">
								<b-row>
									<b-col md="6">
										<b-table :items="insurances.slice(0, 6)" :fields="['insurance_rate_type', 'contract_rate(%)']">
											<template v-slot:cell(contract_rate(%))="info">
											<div class="d-flex" v-if="Object.keys(rates).length === 7">
												<input type="text" v-model="rates[info.index+1]" class="form-control" placeholder="Add rate in %" />
											</div>
											<div class="d-flex" v-else>
												<input type="text" v-model="rates[info.index]" class="form-control" placeholder="Add rate in %" />
											</div>
											</template>
										</b-table>
										</b-col>

										<b-col md="6">
										<b-table :items="insurances.slice(6, 12)" :fields="['insurance_rate_type', 'contract_rate(%)']">
											<template v-slot:cell(contract_rate(%))="info">
											<div class="d-flex">
												<input type="text" v-model="rates2[info.index+1]" class="form-control" placeholder="Add rate in %" />
											</div>
											</template>
										</b-table>
									</b-col>
								</b-row>
							</b-card>

							
							</b-card-body>
						</b-collapse>
					</template>

						<b-card-header header-tag="header" role="tab" class="p-0">
							<b-button
								block
								v-b-toggle.collapseAdditional
								variant="light"
								role="tab"
								class="text-left px-4 py-3 m-0"
								>Details</b-button
							>
						</b-card-header>
						<b-collapse id="collapseAdditional" role="tabpanel">
							<b-card-body>
								

								<b-row>
								<!-- First Column -->
								<b-col md="6">
									<validation-provider vid="region" name="Region" :rules="{ required: false, max: 60 }" v-slot="validationContext">
										<b-form-group label="Region" label-for="region" label-cols-lg="4">
											<b-form-input name="region" type="text" v-model="entity.region" :state="getValidationState(validationContext)" :disabled="saving" />
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
										</b-form-group>
									</validation-provider>
								
									


									<!-- Division -->
									<validation-provider vid="division" name="Division" :rules="{ required: false, max: 60 }" v-slot="validationContext">
										<b-form-group label="Division" label-for="division" label-cols-lg="4">
											<b-form-input name="division" type="text" v-model="entity.division" :state="getValidationState(validationContext)" :disabled="saving" />
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
										</b-form-group>
									</validation-provider>
									

									<!-- OU Number -->
									<validation-provider vid="ou_number" name="OU Number" :rules="{ required: false, max: 60 }" v-slot="validationContext">
									<b-form-group label="OU Number" label-for="ou_number" label-cols-lg="4">
										<b-form-input name="ou_number" type="text" v-model="entity.ou_number" :state="getValidationState(validationContext)" :disabled="saving" />
										<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
									</b-form-group>
									</validation-provider>
								</b-col>

								<!-- Second Column -->
								
								
									<b-col md="6">
										<b-row>
											<b-col>
												<validation-provider vid="territory" name="Territory" :rules="{ required: false, max: 60 }" v-slot="validationContext">
													<b-form-group label="Territory" label-for="territory" label-cols-lg="4">
														<b-form-input name="territory" type="text" v-model="entity.territory" :state="getValidationState(validationContext)" :disabled="saving" />
														<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
													</b-form-group>
												</validation-provider>
											</b-col>
											<b-col>
												<validation-provider vid="area_name" name="Area" :rules="{ required: false, max: 60 }" v-slot="validationContext">
													<b-form-group label="Area" label-for="area_name" label-cols-lg="4">
														<b-form-input name="area_name" type="text" v-model="entity.area_name" :state="getValidationState(validationContext)" :disabled="saving" />
														<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
													</b-form-group>
												</validation-provider>
											</b-col>
										</b-row>
										
			

									<!--  Internal Owner -->
									<validation-provider vid="int_owner" name="Internal Owner" :rules="{ required: false, max: 60 }" v-slot="validationContext">
									<b-form-group label="Internal Owners" label-for="int_owner" label-cols-lg="4">
										<b-form-input name="int_owner" type="text" v-model="entity.internal_owner" :state="getValidationState(validationContext)" :disabled="saving" />
										<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
									</b-form-group>
									</validation-provider>
									<!-- BU Number -->
									<validation-provider vid="bu_number" name="BU Number" :rules="{ required: false, max: 60 }" v-slot="validationContext">
									<b-form-group label="BU Number" label-for="bu_number" label-cols-lg="4">
										<b-form-input name="bu_number" type="text" v-model="entity.bu_number" :state="getValidationState(validationContext)" :disabled="saving" />
										<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
									</b-form-group>
									</validation-provider>
								</b-col>
								</b-row>
								<p class="font-weight-bold">No. of beds</p>
                                <b-row>
                                    <!-- Skilled Field -->
                                      <b-col md="3">
                                          <validation-provider vid="skilled" name="Skilled" :rules="{ required: false, min_value: 0, max: 60 }" v-slot="validationContext">
                                              <b-form-group label="Skilled" label-for="skilled" label-cols-lg="4">
                                                  <b-form-input name="skilled" type="text" v-model="entity.skilled" :state="getValidationState(validationContext)" :disabled="saving" />
                                                  <b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
                                              </b-form-group>
                                          </validation-provider>
                                      </b-col>
 
                                     <!-- LTC Field -->
                                     <b-col md="3">
                                         <validation-provider vid="ltc" name="LTC" :rules="{ required: false, min_value: 0, max: 60 }" v-slot="validationContext">
                                             <b-form-group label="LTC" label-for="ltc" label-cols-lg="4">
                                                 <b-form-input name="ltc" type="text" v-model="entity.ltc" :state="getValidationState(validationContext)" :disabled="saving" />
                                                 <b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
                                             </b-form-group>
                                         </validation-provider>
                                     </b-col>
 
                                     <!-- AI Field -->
                                     <b-col md="3">
                                         <validation-provider vid="ai" name="AI" :rules="{ required: false, min_value: 0, max: 60 }" v-slot="validationContext">
                                             <b-form-group label="AI" label-for="ai" label-cols-lg="4">
                                                 <b-form-input name="ai" type="text" v-model="entity.ai" :state="getValidationState(validationContext)" :disabled="saving" />
                                                 <b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
                                             </b-form-group>
                                         </validation-provider>
                                     </b-col>
 
                                     <!-- IL Field -->
                                     <b-col md="3">
                                         <validation-provider vid="il" name="IL" :rules="{ required: false, min_value: 0,  max: 60 }" v-slot="validationContext">
                                             <b-form-group label="IL" label-for="il" label-cols-lg="4">
                                                 <b-form-input name="il" type="text" v-model="entity.il" :state="getValidationState(validationContext)" :disabled="saving" />
                                                 <b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
                                             </b-form-group>
                                         </validation-provider>
                                     </b-col>
                                </b-row>
								
							</b-card-body>
						</b-collapse>
						<!-- Details section end  -->

						<!-- Contact section start-->
						<b-card-header header-tag="header" role="tab" class="p-0">
						<b-button
							block
							v-b-toggle.collapseContact
							variant="light"
							role="tab"
							class="text-left px-4 py-3 m-0"
							>Contact</b-button
						>
						</b-card-header>
						<b-collapse id="collapseContact" role="tabpanel">
							<b-card-body>
								<b-row>
								<!-- First Column -->
								<b-col md="6">
									<validation-provider
										vid="phone"
										name="Phone"
										:rules="{ required: false }"
										v-slot="validationContext"
									>
										<b-form-group label="Main Phone" label-for="phone" label-cols-lg="4">
											<b-form-input
												name="phone"
												type="text"
												v-model="entity.phone"
												v-mask="'(###) ###-####'"
												:state="getValidationState(validationContext)"
												:disabled="saving"
											/>
											<b-form-invalid-feedback
												v-for="error in validationContext.errors"
												:key="error"
												v-text="error"
											/>
										</b-form-group>
									</validation-provider>

									<validation-provider
										vid="email"
										name="Email"
										:rules="{ required: false }"
										v-slot="validationContext"
									>
										<b-form-group label="Main Email" label-for="email" label-cols-lg="4">
											<b-form-input
												name="email"
												type="email"
												v-model="entity.email"
												:state="getValidationState(validationContext)"
												:disabled="saving"
											/>
											<b-form-invalid-feedback
												v-for="error in validationContext.errors"
												:key="error"
												v-text="error"
											/>
										</b-form-group>
									</validation-provider>
									
								</b-col>

								<!-- Second Column -->
								<b-col md="6">
									<validation-provider
										vid="website"
										name="Website"
										:rules="{ required: false }"
										v-slot="validationContext"
									>
										<b-form-group label="Main Website" label-for="website" label-cols-lg="4">
											<b-form-input
												name="website"
												type="url"
												v-model="entity.website"
												:state="getValidationState(validationContext)"
												:disabled="saving"
											/>
											<b-form-invalid-feedback
												v-for="error in validationContext.errors"
												:key="error"
												v-text="error"
											/>
										</b-form-group>
									</validation-provider>

									<validation-provider
										vid="fax"
										name="Fax"
										:rules="{ required: false }"
										v-slot="validationContext"
									>
										<b-form-group label="Main Fax" label-for="fax" label-cols-lg="4">
											<b-form-input
												name="fax"
												type="text"
												v-model="entity.fax"
												v-mask="'(###) ###-####'"
												:state="getValidationState(validationContext)"
												:disabled="saving"
											/>
											<b-form-invalid-feedback
												v-for="error in validationContext.errors"
												:key="error"
												v-text="error"
											/>
										</b-form-group>
									</validation-provider>
								</b-col>
								</b-row>

								<b-input-group-append>
									<b-button variant="light" class="mb-1 btn btn-outline-success" @click="createNewForm">
									   <font-awesome-icon icon="plus" fixed-width />
									   <span>Add Contacts</span>
									</b-button>
								  </b-input-group-append>

								  <form v-for="(form, index) in forms" :key="`form-${index}`" class="mb-2">
									<b-card body>
										<b-row>
											<!-- First Column -->
											<b-col md="4">
												<validation-provider
													vid="title_id"
													name="Main_Title"
													:rules="{ required: true, numeric: true }"
													v-slot="validationContext"
												>
													<b-form-group
														label="Title"
														label-for="title_id"
														label-cols-lg="4"
													>
														<b-input-group>
															<b-form-select
																name="title_id"
																v-model="form.title_id"
																:options="titlename"
																:disabled="saving || loadingtitlename"
																:state="getValidationState(validationContext)"
																value-field="id"
																text-field="full_name"
																
															>
															
																<template #first>
																	<option disabled v-if="!hastitlename" :value="null">
																	Please Select Title
																	</option>
																</template>
															</b-form-select>
															<template #append>
																<b-button
																	variant="primary"
																	@click="openCustomTitle"
																>
																	<font-awesome-icon icon="plus" fixed-width />
																</b-button>
															</template>
														</b-input-group>
														<b-form-invalid-feedback
															v-for="error in validationContext.errors"
															:key="error"
															v-text="error"
														/>
													</b-form-group>
												</validation-provider>
												
													
												<validation-provider vid="phone" name="Phone" :rules="{ required: false }" v-slot="validationContext">
																<div class="d-flex align-items-end">
																	<b-form-group label="Contact Number Type" label-for="type" label-cols-lg="4">
																	<!-- Dropdown (select) field -->
																	<b-input-group class="mb-3">
																		<label :for="'contacType' + index"></label>
																		<b-form-select
																		name="conatct_id"
																		v-model="form.contact_id"
																		:options="contactTypes"
																		:disabled="saving || loadingcontactTypes"
																		:state="getValidationState(validationContext)"
																		value-field="id"
																		text-field="full_name"
																		>
																		<template #first>
																			<option disabled v-if="!hascontactTypes" :value="null">
																			Please Select Contact Type
																			</option>
																		</template>
																		</b-form-select>
																	</b-input-group>
																	</b-form-group>
																</div>
																</validation-provider>

															</b-col>

															<!-- Second Column -->
															<b-col md="4">
																<validation-provider
																vid="f_name"
																name="First_Name"
																:rules="{ required: false }"
																v-slot="validationContext"
															>
																<b-form-group label="First Name" label-for="f_name" label-cols-lg="4">
																	<b-form-input
																		name="f_name"
																		type="text"
																		v-model="form.first_name"
																		:state="getValidationState(validationContext)"
																		:disabled="saving"
																	/>
																	<b-form-invalid-feedback
																		v-for="error in validationContext.errors"
																		:key="error"
																		v-text="error"
																	/>
																</b-form-group>
															</validation-provider>

															<validation-provider vid="phone" name="Phone" :rules="{ required: false }" v-slot="validationContext">
    <div class="mb-3 d-flex align-items-end">
        <label :for="'phone' + index" class="mr-2" label-cols-lg="4">Contact Number</label>
        <b-input-group style="width: 100%;">
            <b-form-input
                :name="'phone' + index"
                type="text"
                v-model="form.phone"
                v-mask="'(###) ###-####'"
                :state="getValidationState(validationContext)"
                :disabled="saving"
            ></b-form-input>

            <!-- Button inside the input group to remove the corresponding field -->
            <b-input-group-append>
                <b-button variant="danger" @click="removeInputField(index)" v-if="inputFields.length > 1">
                    <font-awesome-icon icon="minus" fixed-width />
                </b-button>
                <!-- Button to add a new input field -->
                <b-button variant="primary" @click="addInputField">
                    <font-awesome-icon icon="plus" fixed-width />
                </b-button>
            </b-input-group-append>
        </b-input-group>

        <b-form-invalid-feedback
            v-for="error in validationContext.errors"
            :key="error"
            v-text="error"
        ></b-form-invalid-feedback>
    </div>
</validation-provider>





																</b-col>
																<!-- Third Column -->
																<b-col md="4">
																<validation-provider
																	vid="l_name"
																	name="Last_Name"
																	:rules="{ required: false }"
																	v-slot="validationContext"
																>
																	<b-form-group label="Last Name" label-for="l_name" label-cols-lg="4">
																		<b-form-input
																			name="l_name"
																			type="text"
																			v-model="form.last_name"
																			:state="getValidationState(validationContext)"
																			:disabled="saving"
																		/>
																		<b-form-invalid-feedback
																			v-for="error in validationContext.errors"
																			:key="error"
																			v-text="error"
																		/>
																	</b-form-group>
																</validation-provider>

																<validation-provider
																	vid="email"
																	name="Email"
																	:rules="{ required: false }"
																	v-slot="validationContext"
																>
																	<b-form-group label="Email" label-for="email" label-cols-lg="4">
																		<b-form-input
																			name="email"
																			type="email"
																			v-model="form.email"
																			:state="getValidationState(validationContext)"
																			:disabled="saving"
																		/>
																		<b-form-invalid-feedback
																			v-for="error in validationContext.errors"
																			:key="error"
																			v-text="error"
																		/>
																	</b-form-group>
																</validation-provider>
																</b-col>

														</b-row>
											
										<b-card-footer class="d-flex justify-content-end">
												<b-button type="button" variant="light"  @click="removeForm(index)" class="btn btn-outline-danger">
												<span>Cancel</span>
												</b-button>
										</b-card-footer>
	
										<b-modal id="customTitle" title="Add Custom Title " @ok="addCustomTitleName">
											<b-form-input
											id="newCustomName"
											name="newCustomeTitleName"
											type="text"
											v-model="form.title_id"
											placeholder="Add custom Title"
											:disabled="saving"
											/>
										</b-modal>
									</b-card>
								  </form>
							</b-card-body>
						</b-collapse>
						<!-- Contact section end-->

						<!-- Contract Section Start
						<b-card-header header-tag="header" role="tab" class="p-0">
							<b-button
								block
								v-b-toggle.collapseContract
								variant="light"
								role="tab"
								class="text-left px-4 py-3 m-0"
								>Contract</b-button
							>
						</b-card-header>
						<b-collapse id="collapseContract" role="tabpanel">
							<b-card-body>
							<b-row>
							 First Column 
							<b-col md="6">
								<validation-provider
									vid="active"
									name="Active"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									
									<b-form-group
										label="Contract Status"
										label-for="contractStatus"
										label-cols-lg="4"
									>
										<b-form-select
											id="contractStatus"
											v-model="contractDetails.contract_status"
											:options="contractStatusOptions"
											:disabled="saving"
											value-field="id"
											text-field="contract_status"
										></b-form-select>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>

								</validation-provider>

								<validation-provider
									vid="contract_end_date"
									name="Contract End Date"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									<b-form-group label="Expiration Date" label-for="contract_end_date" label-cols-lg="4">
										<b-form-input
											type="date"
											v-model="contractDetails.contract_end_date"
											name="contract_end_date"
											:disabled="saving"
											:state="getValidationState(validationContext)"
											:style="{ color: contractDetails.contract_status === 2 ? 'red' : contractDetails.contract_status === 3 ? '#FFD700' : 'inherit' }"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider>

								

							</b-col>

							 Second Column 
							<b-col md="6">
								<validation-provider
									vid="contract_start_date"
									name="Contract Start Date"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									<b-form-group label="Contract Effective Date" label-for="contract_start_date" label-cols-lg="4">
										<b-form-input
											type="date"
											v-model="contractDetails.contract_start_date"
											name="contract_start_date"
											:disabled="saving"
											:state="getValidationState(validationContext)"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider>

								<validation-provider
									vid="renewal_date"
									name="Renewal Date"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									<b-form-group label="Renewal Date" label-for="renewal_date" label-cols-lg="4">
										<b-form-input
											type="date"
											v-model="contractDetails.renewal_date"
											name="renewal_date"
											:disabled="saving"
											:state="getValidationState(validationContext)"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider>

								</b-col>
								</b-row>

									<b-row>
									 First Column 
									<b-col md="6">
										 Contract Bill Type 
										<validation-provider
										vid="contract_bill_type"
										name="Contract Bill Type"
										:rules="{ required: false }"
										v-slot="validationContext"
										>
										<b-form-group label="Contract Bill Type" label-for="contract_bill_type" label-cols-lg="4">
											<b-form-select
											name="contract_bill_type"
											v-model="contractDetails.contract_bill_type"
											:state="getValidationState(validationContext)"
											:options="contractBillTypes"
											:disabled="saving"
											value-field="value"
											text-field="text"
											>
											
											</b-form-select>
											<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
											/>
										</b-form-group>
										</validation-provider>

										<validation-provider
										vid="indemnification_days"
										name="Indemnification Days"
										:rules="{ required: false, min: 0, max: 365 }"
										v-slot="validationContext"
									>
										<b-form-group
											label="Indemnification Days"
											label-for="indemnification_days"
											label-cols-lg="4"
											description="Days exceeded for Indemnification"
										>
											<b-form-input
												name="indemnification_days"
												type="number"
												step="1"
												min="0"
												max="365"
												default="30"
												v-model="contractDetails.indemnification_days"
												:disabled="saving"
												:state="getValidationState(validationContext)"
											/>
											<b-form-invalid-feedback
												v-for="error in validationContext.errors"
												:key="error"
												v-text="error"
											/>
										</b-form-group>
									</validation-provider>

									</b-col>

									 Second Column 
									<b-col md="6">
										 Contract Type 
										<validation-provider
										vid="contract_type"
										name="Contract Type"
										v-slot="validationContext"
										>
										<b-form-group label="Contract Type" label-for="contract_type" label-cols-lg="4">
											<b-form-select
											name="contract_type"
											v-model="contractDetails.contract_type"
											:state="getValidationState(validationContext)"
											:options="contractTypes"
											:disabled="true"
											value-field="value"
											text-field="text"
											direction="down"
											/>
											<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
											/>
										</b-form-group>
										</validation-provider>

										<validation-provider
										vid="max_return_work_days"
										name="Max Return Days"
										:rules="{ required: false, min: 0, max: 365 }"
										v-slot="validationContext"
									>
										<b-form-group
											label="Max Return Days"
											label-for="max_return_work_days"
											label-cols-lg="4"
											description="Maximum days to return work to facility"
										>
											<b-form-input
												name="max_return_work_days"
												type="number"
												step="1"
												min="0"
												max="365"
												default="30"
												v-model="contractDetails.max_return_work_days"
												:disabled="saving"
												:state="getValidationState(validationContext)"
											/>
											<b-form-invalid-feedback
												v-for="error in validationContext.errors"
												:key="error"
												v-text="error"
											/>
										</b-form-group>
									</validation-provider>
									</b-col>
								</b-row>

								<validation-provider
								vid="service_operations"
								name="Service Operations"
								:rules="{ required: false }"
								v-slot="validationContext"
								>
								<b-form-group label="Service Operations" label-for="service_operations" label-cols-lg="2">
									<b-form-checkbox-group
									id="service_operations"
									v-model="contractDetails.serviceOperation"
									:options="serviceOperationsOptions"
									:state="getValidationState(validationContext)"
									:disabled="saving"
									/>
									<b-form-invalid-feedback
									v-for="error in validationContext.errors"
									:key="error"
									v-text="error"
									/>
								</b-form-group>
								</validation-provider>

								<b-card title="Contract Pricing Schedule" border-variant="light">
								<b-row>
									<b-col md="6">
										<b-table :items="insurances.slice(0, 6)" :fields="['insurance_rate_type', 'contract_rate']">
											<template v-slot:cell(contract_rate)="info">
											<div class="d-flex">
												<input type="text" v-model="rates[info.index+1]" class="form-control" placeholder="Add rate in %" />
											</div>
											</template>
										</b-table>
										</b-col>

										<b-col md="6">
										<b-table :items="insurances.slice(6, 12)" :fields="['insurance_rate_type', 'contract_rate']">
											<template v-slot:cell(contract_rate)="info">
											<div class="d-flex">
												<input type="text" v-model="rates2[info.index+1]" class="form-control" placeholder="Add rate in %" />
											</div>
											</template>
										</b-table>
									</b-col>
								</b-row>
							</b-card>

							
							</b-card-body>
						</b-collapse> -->
						<!-- Contract Section End-->

						<!--Service section start-->
						<!-- <b-card-header header-tag="header" role="tab" class="p-0">
							<b-button
								block
								v-b-toggle.collapseServices
								variant="light"
								role="tab"
								class="text-left px-4 py-3 m-0"
								>Services</b-button
							>
						</b-card-header>
						<b-collapse id="collapseServices" role="tabpanel">
							<b-card-body>

									<b-form-group label="Assigned Services" label-for="service_ids" label-cols-lg="4" class="mb-0" style="margin: 0;">
									<loading-indicator v-if="loadingServices && services.length <= 0" />
									<b-input-group>
										<b-form-input type="text" name="service_ids" v-model="searchQuery"
											:disabled="saving || loadingServices"
											placeholder="Search for a Service..." @input="filterServices" class="mb-0" />
										
									</b-input-group>
									<div class="mb-0" style="margin: 0;">
										
										<b-list-group v-if="selectedServices.length > 0" class="mb-0">
											<b-list-group-item v-for="service in selectedServices" :key="service.id" class="mb-0">
												<div class="d-flex justify-content-between align-items-center mb-0">
													<div class="mb-0">{{ service.name }}</div>
													<b-btn variant="danger" @click="deselectService(service)" size="sm">
														
														<font-awesome-icon
															icon="times"
															fixed-width
														/>
													</b-btn>
												</div>
											</b-list-group-item>
										</b-list-group>

									</div>
									<div v-if="filteredServices.length > 0" class="mb-0">
										<b-list-group>
											<b-list-group-item v-for="service in filteredServices" :key="service.id"
												@click="selectService(service)">
												{{ service.name }}
											</b-list-group-item>
										</b-list-group>
									</div>
								</b-form-group>
								

							</b-card-body>
						</b-collapse> -->
						<!--Service section End-->

						<!--Receiving Methods section start-->
						<b-card-header header-tag="header" role="tab" class="p-0">
							<b-button
								block
								v-b-toggle.collapseReceivingMethods
								variant="light"
								role="tab"
								class="text-left px-4 py-3 m-0"
							>Outgoing Methods</b-button>
						</b-card-header>
						<b-collapse id="collapseReceivingMethods" role="tabpanel">
							<b-card-body>

								<template>
									<div>
										<b-row>
										<!-- Section for Receiving Emails -->
										<b-col md="6">
											
											<!-- Display entered emails in tabular format -->
											<div>
												<h6>Outgoing Emails</h6>
												<b-table v-if="entity && entity.receiving_emails && entity.receiving_emails.length > 0" :items="entity.receiving_emails" :fields="['email', 'description']" striped hover>
												<template slot="cell(email)" slot-scope="info">
													{{ info.item.email }}
												</template>
												<template slot="cell(description)" slot-scope="info">
													{{ info.item.description }}
												</template>
												</b-table>
												<empty-result v-else class="small-empty-result">
												<span>No emails added</span>
												</empty-result>
											</div>

											<div class="d-flex justify-content-between">
												<!-- Plus icon button on the left -->
												<b-button @click="openPopup" variant="primary">
													<font-awesome-icon icon="plus" fixed-width />
												</b-button>

												<b-button @click="openDeletePopup" variant="danger" v-if="entity.receiving_emails && entity.receiving_emails.length > 0" class="mr-8">
													<font-awesome-icon icon="trash" fixed-width />
												</b-button>
											</div>

											<!-- Pop-up for adding emails -->
											<b-modal v-model="popupVisible" title="Add Email" hide-footer>
												<b-form @submit.prevent="addEmail">
												<b-form-group label="Email" label-for="email">
													<b-form-input v-model="newEmail.email" id="email" required />
												</b-form-group>
												<b-form-group label="Description" label-for="description">
													<b-form-input v-model="newEmail.description" id="description" />
												</b-form-group>
												<b-button type="submit" variant="primary" class="mx-auto d-block"> Ok</b-button>
												</b-form>
											</b-modal>


											<!-- Pop-up for deleting selected entries -->
											<b-modal v-model="deletePopupVisible" title="Delete Emails" @ok="deleteSelectedEmails" ok-only>
												<b-form>
												<div> <!-- Wrap the b-table in a div -->
													<b-table :items="entity.receiving_emails" :fields="['email', 'description']" striped hover>
													<template #cell(email)="info">
														<div class="d-flex align-items-center">
														<b-form-checkbox v-model="selectedEmails" :value="info.item" class="mr-2" />
														<span>{{ info.item.email }}</span>
														</div>
													</template>
													<template #cell(description)="info">
														{{ info.value }}
													</template>
													</b-table>
												</div>
												</b-form>
												<template #modal-footer="{ ok }">
												<b-button @click="deleteSelectedEmails" variant="primary" class="mx-auto d-block">OK</b-button>
												</template>
											</b-modal>
											
										</b-col>

										<!-- Section for Receiving Faxes -->
										<b-col md="6">
											
											<!-- Display entered faxes in tabular format -->
											<div>
												<h6>Outgoing Faxes</h6>
												<b-table v-if="entity && entity.receiving_faxes && entity.receiving_faxes.length > 0" :items="entity.receiving_faxes" :fields="['fax', 'description']" striped hover>
												<template slot="cell(fax)" slot-scope="info">
													{{ info.value }}
												</template>
												<template slot="cell(description)" slot-scope="info">
													{{ info.value }}
												</template>
												</b-table>
												<empty-result v-else class="small-empty-result">
												<span>No faxes added</span>
												</empty-result>
											</div>

											<!-- Icon to open the pop-up -->
											<div class="d-flex justify-content-between">
												<!-- Plus icon button on the left -->
												<b-button @click="openPopupFax" variant="primary">
												<font-awesome-icon icon="plus" fixed-width />
												</b-button>

												<b-button @click="openDeleteFaxPopup" variant="danger" v-if="entity.receiving_faxes && entity.receiving_faxes.length > 0" class="mr-8">
												<font-awesome-icon icon="trash" fixed-width />
												</b-button>
											</div>

											<!-- Pop-up for adding faxes -->
											<b-modal v-model="popupVisibleFax" title="Add Fax" hide-footer>
												<b-form @submit.prevent="addFax">
													<b-form-group label="Fax" label-for="fax">
														<b-form-input v-model="newFax.fax" @input="formatFax" id="fax" required />
													</b-form-group>
													<b-form-group label="Description" label-for="description">
														<b-form-input v-model="newFax.description" id="description" />
													</b-form-group>
													<b-button type="submit" variant="primary" class="mx-auto d-block">Ok</b-button>
												</b-form>
											</b-modal>




											<!-- Pop-up for deleting selected entries -->
											<b-modal v-model="deletePopupVisibleFax" title="Delete Faxes" @ok="deleteSelectedFaxes" ok-only>
												<b-form>
												<div> <!-- Wrap the b-table in a div -->
													<b-table :items="entity.receiving_faxes" :fields="['fax', 'description']" striped hover>
													<template #cell(fax)="info">
														<div class="d-flex align-items-center">
														<b-form-checkbox v-model="entity.selectedFaxes" :value="info.item" :key="info.item.fax" class="mr-2" />
														<span>{{ info.item.fax }}</span>
														</div>
													</template>
													<template #cell(description)="info">
														{{ info.value }}
													</template>
													</b-table>
												</div>
												</b-form>
												<template #modal-footer="{ ok }">
												<b-button @click="deleteSelectedFaxes" variant="primary" class="mx-auto d-block">OK</b-button>
												</template>
											</b-modal>
											<!-- </b-form-group> -->
										</b-col>
										</b-row>
									</div>
									</template>
								


							</b-card-body>
						</b-collapse>

						<!-- end Receiving Methods -->


						<!--NPI information section start-->

					<b-card-header v-if="fromNPI" header-tag="header" role="tab" class="p-0">
					<b-button block v-b-toggle.collapseNpiInformation variant="light" role="tab"
						class="text-left px-4 py-3 m-0">
						NPI Information
					</b-button>
					</b-card-header>

					<b-collapse id="collapseNpiInformation" role="tabpanel" v-if="showNpiSection">
						<b-card-body>
							<div class="d-flex">
								<div class="flex-grow-1 pr-3">
									<div class="label-value-row">
										<div class="label-text">Name:</div>
										<div class="text">{{ entity.name }}</div>
									</div>
									<div class="label-value-row">
										<div class="label-text">NPI Number:</div>
										<div class="text">{{ entity.npi_number }}</div>
									</div>
									<hr class="my-2">
									<div class="label-value-row">
										<div class="label-text">Enumeration Type:</div>
										<div class="text">{{ ` ${entity.enumeration_type} Organization` }}</div>
									</div>
									
									<div class="label-value-row">
										<div class="label-text">Status</div>
										<div class="text">{{ entity.active ? 'Active' : 'Inactive' }}</div>
									</div>
									

									<hr class="my-2">

									
											<div class="d-flex">
												<div class="flex-grow-1 pr-3">
												<div class="label-value-row">
													<div class="label-text">Location Address:</div>
													<div class="text">{{ entity.address_2 }}</div>
											</div>
											<div class="label-value-row">
												<div class="label-text">Phone Number:</div>
												<div class="text">{{ entity.location_phone }}</div>
											</div>
											<hr class="my-1">
											<div class="label-value-row">
												<div class="label-text">Mailing Address:</div>
												<div class="text">{{entity.address_1}}</div>
											</div>
											<!-- <div class="label-value-row">
												<div class="label-text">Organization Subpart ?</div>
												<div class="text-primary">{{ entity.organizational_subpart }}</div>
											</div> -->
											<div class="label-value-row">
												<div class="label-text">Phone Number:</div>
												<div class="text">{{ entity.mailing_phone }}</div>
											</div>
										</div>
									</div>


									<hr class="my-2">

									<div class="d-flex">
										<div class="flex-grow-1 pr-3">
											<div class="label-value-row">
												<div class="label-text">Primary Taxonomy:</div>
												<div class="text">{{ entity.primary_taxonomy }}</div>
											</div>
											<hr class="my-2">
											<div class="label-value-row">
												<div class="label-text">Additional Taxonomies:</div>
												<div class="text">{{ processAdditionalTaxonomies(entity.additional_taxonomies) }}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</b-card-body>
					</b-collapse>

					<!--NPI information section end-->
				
					</b-card>
				

				
				<b-card-footer>
					<b-row>
						<b-col cols="12" md="6" xl="4" class="mb-4 mb-md-0">
							<b-button block variant="light" type="button" @click.stop="cancel" class="btn btn-outline-danger">
								<span>Cancel</span>
							</b-button>
						</b-col>
						<b-col cols="12" md="6" offset-xl="4" xl="4" class="mb-2 mb-md-0">
							<b-button block variant="light" type="submit" :disabled="saving" class="btn btn-outline-success">
								<font-awesome-icon icon="circle-notch" v-if="saving" spin fixed-width />
								<span>Save</span>
							</b-button>
						</b-col>
					</b-row>
				</b-card-footer>
			</b-card>
		</b-form>
	</validation-observer>
</template>

<script type="text/javascript">
import { mapGetters} from "vuex";
import { formatErrors, getValidationState } from "@/validation";
import NPIOrganization from "@/clients/components/NPI/NPIOrganization.vue";
import axios from "axios";
import { ref} from "vue";
// get All record
const records = ref([]);

export default {
	name: "FacilityForm",
	components: {
		NPIOrganization,
	},
	props: {
		id: {
			default: null,
		},
	},
	data() {
		return {
			loading: true,
			saving: false,
			npiLookingUp: false,
			npiSearched: false,
			npiResults: [],
			searchChain:'',
			selectedChain: '',
			filteredChains:[],
			searchQuery: '',            // The search query entered by the user
        	// availableServices: [],               // The list of all available services
        	// matchingServices: [],       // The list of services matching the search query
        	filteredServices: [], 
			selectedServices: [],		 // The list of services selected by the user
			// services: [],
			today: new Date().toISOString().split('T')[0],
			entity: {
				id: this.id,
				name: "",
				display_name:null,
				prior_name:null,
				facility_type_id: null,
				active: true,
				phone: null,
				fax: null,
				email: null,
				website: null,
				f_name: null,
				l_name: null,
				title_id: null,
				street_address_1: null,
				street_address_2: null,
				city: null,
				state: null,
				zip: null,
				county: null,
				npi_number: null,
				npi_manual: null,
				primary_taxonomy: null,
				location_phone: null,
				mailing_phone: null,
				additional_taxonomies: null,
				client_owned: false,
				chain_name: '',
				area_name: null,
				ou_number: null,
				bu_number: null,
				territory: null,
				// rvp_name: null,
				has_contract: false,
				// service_operations: null,
				address_1: null,
				address_2: null,
				// taxonomy_code: null,
				// taxonomy_desc: null,
				// taxonomy_group: null,
				// taxonomy_license:  null,
				// taxonomy_state: null,
				othername: null,
				enumeration_type: null,
				organizational_subpart:null,
				services: [],
				chains:[],
				receiving_email: '', // For input
            	receiving_emails: [], // For storing multiple emails
				receiving_fax: '', // For input
            	receiving_faxes: [], // For storing multiple faxes 
				// outgoing_emails: [],
            	receiving_methods: [], 
				facility_status:null,
				internal_owner:null,
				bill_type:'Unknown',
				skilled: null,
                ltc: null,
                ai: null,
                il: null,
				pricing_schedules: [],
				chain_name:null,
				is_duplicate:false,
				original_start_date: null,
				term_date: null,
				contract_status:null,
				contract_end_date: null,
				contract_start_date: null,
				renewal_date: null,
				indemnification_days: null,
				max_return_work_days: null,
				serviceOperation: null,
				contract_bill_type: null,
				contract_type: null,
				ownership_type: null,
			},
			receiving_emails: [], // For storing multiple emails
			receiving_faxes: [], // For storing multiple faxes 
			contractDetails: {
					// facility_id: this.id,
					original_start_date: null,
					term_date: null,
					contract_status:null,
					contract_end_date: null,
					contract_start_date: null,
					renewal_date: null,
					indemnification_days: 10,
					max_return_work_days: null,
					serviceOperation: null,
					contract_bill_type: null,
					contract_type: null,
					ownership_type: null,
					
					
    		},
			billTypeOptions:[],
			facilityStatus:[],
			service_ids: [],
			forms: [],
			titlename: [],
			contactTypes: [],
			inputFields: [{ selectedContactType: 'phone', phone: '' }],
			popupVisible: false,
			popupVisibleFax: false,
			deletePopupVisible: false,
			deletePopupVisibleFax: false,
			isFaxInputDisabled: false,
			newEmail: {
				email: '',
				description: '',
			},
			selectedEmails: [],
			newFax: {
				fax: '',
				description: '',
			},
			selectedFaxes: [],
			showDeleteIcon: false,
			//contract
			serviceOperationsOptions: [],
			fullserviceOperationsOptions: [],
			contractBillTypes: [],
			fullcontractBillTypes: [],
			contractTypes: [],
			fullcontractTypes: [],
			ownershipTypes: [],
			fullownershipTypes: [],
			insurances: [],
			insuranceRates: {},
			selectedInsuranceId: null,
			contract_insurance_type: null,
			newSchedule: {
				insurance_type_id: '',
				contract_rate: '',
						// facility_id: ''
					},
			// end contract
			facilityTypes:[],
			rates:{},
			rates2:{},
			contractStatusOptions:[],
			showNpiSection:false,
			termMinDate:''
	 };
	},
	watch: {
		'entity.bill_type': function(newBillType) {
		if (newBillType === 'Synergy' || newBillType === 'Contract Bill Other' || newBillType === 'GHC' || newBillType === 'Encore' ||  newBillType === 'CB Internal/GHC' ||  newBillType === 'Contract Bill East' ||  newBillType === 'Contract Bill West') {
			this.entity.has_contract = true;
		} else {
			this.entity.has_contract = false;
		}
		},
		// 'entity.npi_number':function(newBillType) {
		// 	this.showNpiSection = true;
		// },
	},
	computed: 
	{
	
		fromNPI() {
				if (this.entity.npi_number !== null) {
					return true;
				}
			},

		...mapGetters({
			states: "states/states",
			// facilityTypes: "facilityTypes/all",
			// loadingFacilityTypes: "facilityTypes/loadingAll",
			services: "services/all",
			loadingServices: "services/loadingAll",
			// chains: "chains/all",
			// loadingChains: "chains/loadingAll",
		}),
	},
	mounted() {
		this.getServices();
		this.getChains();
		this.TitleShow();
    	this.fetchContactTypes();
		this.listFacilityContacts();
		this.fetchFacilityStatus();
		this.fetchFacilityBillType();
		this.fetchContractBillTypes();
		this.fetchContractTypes();
		this.fetchOwnershipTypes();
		this.fetchServiceOperations();
		this.fetchInsurances();
		this.fetchFacilityType();
		this.listFacilityContracts();
		this.listDefaultContractPricingSchedules();
		// this.listContractPricingSchedules();
		

		if (this.id) {
			this.refresh();
		} else {
			this.loading = false;
		}
	},
	
	methods: {
	
	onOriginalStartDateChange() {
    	const today = new Date(this.contractDetails.original_start_date);
    	const year = today.getFullYear();
    	const month = String(today.getMonth() + 1).padStart(2, '0'); 
    	const day = String(today.getDate()).padStart(2, '0');
		this.termMinDate= `${year}-${month}-${day}`;
     },

		// 		async saveContractPricingSchedule() {
		// 			try {
		// 				const apiUrl = '/client/contractpricingschedule';

		// 				const newSchedule = { ...this.newSchedule };
		// 				const ins_id = newSchedule.ins_id;
		// 				const rate = newSchedule.rate;
						
		// 				// Check if pricing_schedules is defined, if not, initialize it as an empty array
		// 				if (!Array.isArray(this.entity.pricing_schedules)) {
		// 					this.$set(this.entity, 'pricing_schedules', []);
		// 				}
		// 			}
		// 			// Add the new email to the array
		// 		this.entity.pricing_schedules.push(newSchedule);
		// 		const ScheduleData = {   
		// 			ins_id,
		// 			rate,
		// 		};
		// 		console.log("header:",ScheduleData);
		// // Clear the newEmail object for the next entry
		// this.newEmail = { email: '', description: '' };
		// 		},
async saveContractPricingSchedule(obj) {
		
		// const newSchedule = { ...this.newSchedule };
		const insurance_type_id = obj.id;
		const contract_rate = obj.rate;


		this.newSchedule.insurance_type_id =insurance_type_id;
		this.newSchedule.contract_rate =contract_rate;



		

		// Check if pricing_schedules is defined, if not, initialize it as an empty array
		if (!Array.isArray(this.entity.pricing_schedules)) {
			this.$set(this.entity, 'pricing_schedules', []);
		}

		
		// Add the new email to the array
		this.entity.pricing_schedules.push(this.newSchedule);

		// // Clear the newEmail object for the next entry
		// this.newEmail = { email: '', description: '' };

		

		// Prepare the data to be sent in the POST request
		const ScheduleData = {   
			insurance_type_id,
			contract_rate,
		};
		
		try {
			// Make a POST request to store the data in the database
			const response = await axios.post('/client/contractpricingschedule', ScheduleData);
			
			await this.$nextTick();
			this.$emit("pricing_schedules", response);
		
			// Check for a successful status code (2xx)
			// if (response.status >= 200 && response.status < 300) {
			// // Parse the JSON response
			// 	const responseData = response.data;
			// 	console.log("data",responseData);
			// 	// Check if the expected properties are present
			// 	if (responseData.ins_id && responseData.rate) 
			// 	{
				if (response.data.success) {
					
					this.saving = false;
					

					this.$nextTick(() => {
						this.$store.dispatch('notify', {
							variant: 'primary',
							title: 'Schedule Created!',
							message: 'New Schedule created.',
						});
					});

					
			} 
			else {
				// Server indicates failure with a non-successful status code
				console.error('Failed to save schedule. Status:', response.status);
				// You can handle different status codes as needed
				// For example, if it's a validation error, show a different notification
				// Or if it's a server error, show an error message
			}
		} catch (error) {
			// console.error(error);
  			// console.log(error.response.data); // Log the response data
			//   console.log('Error Response:', error.response);
			console.error('Error creating schedule:', error);
		}
},

		async saveContract() {
			try {
				console.log('inside save contract', this.entity);

				const apiUrl = '/client/facilitiescontracts/edit';

				// Extract contract-related data from entity
				if(this.entity.has_contract === false) {
					this.contractDetails.indemnification_days = null;
				}
				const contractData = {data:this.contractDetails,id:this.entity.id};
				

				// Make the API call with the extracted data
				const response = await axios.post(apiUrl, contractData);

				// Handle success response if needed
			

				// Optionally notify the user or perform other actions
			} catch (error) {
				// Handle error
				console.error('Error saving Facilities Contract:', error);

				// Optionally notify the user or perform other error handling actions
			}
		},


		async fetchFacilityType(){
			try
						{
							const url = "/client/facilitytypes";
								
								const response = await axios.get(url, {
								headers: {
									"Accept": "application/json",
									// You can add other headers here if needed
								},
								});
								
						
							response.data.forEach((item)=>{
								this.facilityTypes.push({name:item.name, id:item.id});
							});
						
						}
					catch (error) 
					{
						console.error("Error fetching data:", error.message);
					}
		},
		
		
		async fetchInsurances(){
			try
						{
							const url = "/client/contractinsurancelist";
								
								const response = await axios.get(url, {
								headers: {
									"Accept": "application/json",
									// You can add other headers here if needed
								},
								});
								
					
							// response.data.forEach((item)=>{
							// 	this.insurances.push(item.insurance_type);
							// });
							this.insurances = response.data.map(item => ({
							id:item.id,
							insurance_rate_type: item.insurance_type,
							rate: this.entity.contract_rate || '',
							facility_id: this.entity.id
						}));
							
						}
					catch (error) 
					{
						console.error("Error fetching data:", error.message);
					}
		},
		async fetchServiceOperations(){
			try
						{
							const url = "/client/serviceoperationlist";
								
								const response = await axios.get(url, {
								headers: {
									"Accept": "application/json",
									// You can add other headers here if needed
								},
								});
								
							
							response.data.forEach((item)=>{
								this.serviceOperationsOptions.push(item.operation);
								this.fullserviceOperationsOptions.push({name:item.operation,id:item.id});
							});
							
						}
					catch (error) 
					{
						console.error("Error fetching data:", error.message);
					}
		},
		async fetchOwnershipTypes() {
    try {
        const url = "/client/ownershiptypelist";
        const response = await axios.get(url, {
            headers: {
                "Accept": "application/json",
            },
        });

        // Process data once
        this.ownershipTypes = [];
        this.fullownershipTypes = [];

        response.data.forEach(item => {
            this.ownershipTypes.push({ value: item.id, text: item.ownership_type });
            this.fullownershipTypes.push({ id: item.id, name: item.ownership_type });
        });

    } catch (error) {
        console.error("Error fetching ownership types:", error.message);
        this.ownershipTypes = []; // Clear lists on error
        this.fullownershipTypes = [];
    }
},


		async fetchContractTypes(){
			try
						{
							const url = "/client/contracttypelist";
								
								const response = await axios.get(url, {
								headers: {
									"Accept": "application/json",
									// You can add other headers here if needed
								},
								});
							
							response.data.forEach((item)=>{
								this.contractTypes.push(item.contract_type);
								this.fullcontractTypes.push({name:item.contract_type , id:item.id});
							});
							
						}
					catch (error) 
					{
						console.error("Error fetching data:", error.message);
					}
		},
		async fetchContractBillTypes(){
			try
						{
							const url = "/client/contractbilltypelist";
								
								const response = await axios.get(url, {
								headers: {
									"Accept": "application/json",
									// You can add other headers here if needed
								},
								});
								
							
							response.data.forEach((item)=>{
								this.contractBillTypes.push({id:item.id , billtype:item.bill_type});
								this.fullcontractBillTypes.push({id:item.id , billtype:item.bill_type});
							});
							
						}
			catch (error) 
						{
							console.error("Error fetching data:", error.message);
						}
			try{
				const url = "/client/api/fetchContractStatus";
								
				const response = await axios.get(url, {
				headers: {
					"Accept": "application/json",
					// You can add other headers here if needed
				},
				});
				this.contractStatusOptions = response.data;

			

			}
			catch (error) 
						{
							console.error("Error COntract Status options data:", error.message);
						}
		},

		getTypeOptions(row) {
		return row.typeOptions.concat(['Custom']);
		},
		getValueOptions(row) {
		return row.valueOptions.concat(['Custom']);
		},

		getPlaceholder(selectedValue) {
		// You can customize the placeholder based on the selected value
		if (selectedValue === 'per_min') {
			return '$0.00/min';
		} else if (selectedValue === 'per_hour') {
			return '$0.00/hr';
		} else if (selectedValue === 'per_diem') {
			return '$0.00/diem';
		} else {
			return 'Enter rate...';
		}
		},
		async updateReceivingMethods(receivingEmailId, receivingFaxId) {
			const facilityId = this.entity.id;
			
			// Determine if receivingEmailId or receivingFaxId is provided
			const data = {
				facility_id: facilityId,
				receiving_email_id: receivingEmailId || null,
				receiving_fax_id: receivingFaxId || null,
			};
			

			try {
				// const response = await axios.post('/client/receivingMethods', data, {
				// 	headers: {
				// 		'Content-Type': 'application/json',
				// 	},
				// });
				const response = await axios.post('/client/receivingMethods', data);
				
			} catch (error) {
				console.error('Error updating receiving methods:', error);
			}
		},
	
	openPopupFax() {
		this.popupVisibleFax = true;
		},
	closePopupFax() {
		this.popupVisibleFax = false;
		},
	formatFax() {
		const numericFax = this.newFax.fax.replace(/\D/g, '');

		if (numericFax.length > 10) {
		this.faxInputError = true; // Invalid fax number
		// this.isFaxInputDisabled = true; // Disable the input field
		} else {
		this.newFax.fax = numericFax ? numericFax.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') : '';
		this.faxInputError = false;
		// this.isFaxInputDisabled = false; // Enable the input field
		}
		},

async addFax() {
    
        const newFax = { ...this.newFax };
        
		const fax = newFax.fax;
		const description = newFax.description;
		
		// Clear the newFax object for the next entry
        this.newFax = { fax: '', description: '' };

        // Validate fax number format
        const faxRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
        if (!faxRegex.test(fax)) {
            this.$bvToast.toast('Error: Please enter a valid fax number. (Format: (123) 456-7890)', {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000, // milliseconds
            });
            return;
        }

        // Check if receiving_faxes is defined, if not, initialize it as an empty array
        if (!Array.isArray(this.entity.receiving_faxes)) {
            this.$set(this.entity, 'receiving_faxes', []);
        }

        // Check if the fax number already exists
        if (this.entity.receiving_faxes.some(existingFax => existingFax.fax === fax)) {
            this.$bvToast.toast('Error: Fax number already exists. Please enter a different fax.', {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000, // milliseconds
            });
            return;
        }

        // Add the new fax to the array
        this.entity.receiving_faxes.push(newFax);

        // Clear the newFax object for the next entry
        this.newFax = { fax: '', description: '' };

        // Close the pop-up
        this.popupVisibleFax = false;

        // Prepare the data to be sent in the POST request
        // Prepare the data to be sent in the POST request
		const faxData = {
			fax,
			description,
		};
		
		// try {
		// 	// Make a POST request to store the data in the database
		// 	const response = await axios.post('/client/receivingFaxes', faxData);
		// 	console.log('Axios Response:', response);
		// 	await this.$nextTick();
		// 	this.$emit("Receiving_faxes", response);
		// 	console.log("Emitted data:", response.data);
		// 	// Check for a successful status code (2xx)
		// if (response.status >= 200 && response.status < 300) {
		// 	// Parse the JSON response
		// 		const responseData = response.data;
		// 		// Check if the expected properties are present
		// 		if (responseData.fax && responseData.description && responseData.id) 
		// 		{
		// 			console.log('Fax saved successfully.');
		// 			this.saving = false;
		// 			await this.updateReceivingMethods(null, responseData.id);

		// 			this.$nextTick(() => {
		// 				this.$store.dispatch('notify', {
		// 					variant: 'primary',
		// 					title: 'Fax Created!',
		// 					message: 'New fax created.',
		// 				});
		// 			});
					
					
		// 	} else {
		// 		// Server response is missing expected properties
		// 		console.error('Invalid server response:', responseData);
		// 	}
		// 	} else {
		// 	// Server indicates failure with a non-successful status code
		// 	console.error('Failed to save fax. Status:', response.status);
		// 	// You can handle different status codes as needed
		// 	// For example, if it's a validation error, show a different notification
		// 	// Or if it's a server error, show an error message
		// 	}
		// } catch (error) {
		// 	console.error('Error creating fax:', error);
		// }
},
    openDeleteFaxPopup() {
      // Show checkboxes and delete icon
      this.showDeleteIcon = true;
      this.deletePopupVisibleFax = true;
    },
    closeDeleteFaxPopup() {
      // Hide checkboxes and delete icon
      this.showDeleteIcon = false;
      this.deletePopupVisibleFax = false;
      // Reset selectedFaxes array
      this.selectedFaxes = [];
    },
    // deleteSelectedFaxes() {
    //   // Add logic to delete selected faxes
    //   // Update the displayedFaxes text
    //   this.displayedFaxes = ''; // Update with your logic
    //   this.closeDeletePopup();
    // },
	async deleteSelectedFaxes() {
		// Add logic to delete selected faxes
		
		const updatedFaxes = this.entity.receiving_faxes.filter(
		(fax) => !this.selectedFaxes.includes(fax.fax)
		);
		
		// Update the receiving_faxes array with the updatedFaxes
		this.entity.receiving_faxes = updatedFaxes;
		const indexToRemove = this.entity.receiving_faxes.findIndex(fax => fax.id === this.entity.selectedFaxes.id);
		// If the index is found (i.e., the fax with the given id exists), remove it
		if (indexToRemove !== -1) {
			this.entity.receiving_faxes.splice(indexToRemove, 1);
		}
		
		
		// Reset selectedFaxes array
		this.selectedFaxes = [];

		// Close the delete popup
		this.closeDeleteFaxPopup();
		const responseOutgoingData = await axios.post('/client/receivingEmails', {data:this.entity.selectedFaxes , fetch:false , add:false , edit:false , delete:true});
	},
	openPopup() {
	this.popupVisible = true;
	},
	closePopup() {
	this.popupVisible = false;
	},

		
	

	async addEmail() {
		const newEmail = { ...this.newEmail };
		const email = newEmail.email;
		const description = newEmail.description;
		// Clear the newEmail object for the next entry
		this.newEmail = { email: '', description: '' };

		// Check if the email is in a valid format
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		if (!emailRegex.test(email)) {
			this.$bvToast.toast('Error: Please enter a valid email address.', {
				title: 'Error',
				variant: 'danger',
				solid: true,
				autoHideDelay: 5000, // milliseconds
		});
		return;
		}


		// Check if receiving_emails is defined, if not, initialize it as an empty array
		if (!Array.isArray(this.entity.receiving_emails)) {
			this.$set(this.entity, 'receiving_emails', []);
		}

		
		// Check if the email already exists
		if (this.entity.receiving_emails.some(existingEmail => existingEmail.email === email)) {
			this.$bvToast.toast('Error: Email address already exists. Please enter a different email.', {
				title: 'Error',
				variant: 'danger',
				solid: true,
				autoHideDelay: 5000, // milliseconds
			});
			return;
		}


		// Add the new email to the array
		this.entity.receiving_emails.push(newEmail);
		
		// Clear the newEmail object for the next entry
		this.newEmail = { email: '', description: '' };

		// Close the pop-up
		this.popupVisible = false;

		// Prepare the data to be sent in the POST request
		const emailData = {   
			email,
			description,
		};
		
		// try {
		// 	// Make a POST request to store the data in the database
		// 	const response = await axios.post('/client/receivingEmails', emailData);
		// 	console.log('Axios Response:', response);
		// 	await this.$nextTick();
		// 	this.$emit("Receiving_emails", response);
		// 	console.log("Emitted data:", response.data);
		// 	// Check for a successful status code (2xx)
		// 	if (response.status >= 200 && response.status < 300) {
		// 	// Parse the JSON response
		// 		const responseData = response.data;
		// 		console.log("id",responseData.id);
		// 		// Check if the expected properties are present
		// 		if (responseData.email && responseData.description && responseData.id) 
		// 		{
		// 		// if (response.data.success) {
		// 			console.log('Email saved successfully.');
		// 			this.saving = false;
		// 			// this.$router.push({ name: 'receivingEmails' });
		// 			await this.updateReceivingMethods(responseData.id, null);

		// 			this.$nextTick(() => {
		// 				this.$store.dispatch('notify', {
		// 					variant: 'primary',
		// 					title: 'Email Created!',
		// 					message: 'New email created.',
		// 				});
		// 			});

		// 	} else {
		// 		// Server response is missing expected properties
		// 		console.error('Invalid server response:', responseData);
		// 	}
		// 	} else {
		// 	// Server indicates failure with a non-successful status code
		// 	console.error('Failed to save email. Status:', response.status);
		// 	// You can handle different status codes as needed
		// 	// For example, if it's a validation error, show a different notification
		// 	// Or if it's a server error, show an error message
		// 	}
		// } catch (error) {
		// 	console.error('Error creating email:', error);
		// }
},

    openDeletePopup() {
      // Show checkboxes and delete icon
      this.showDeleteIcon = true;
      this.deletePopupVisible = true;
    },
    closeDeletePopup() {
      // Hide checkboxes and delete icon
      this.showDeleteIcon = false;
      this.deletePopupVisible = false;
      // Reset selectedEmails array
      this.selectedEmails = [];
    },
    // deleteSelectedEmails() {
    //   // Add logic to delete selected emails
    //   // Update the displayedEmails text
    //   this.displayedEmails = ''; // Update with your logic
    //   this.closeDeletePopup();
    // },
	async deleteSelectedEmails() {
  
	this.selectedEmails.forEach(selectedEmail => {
    // Find the index of selectedEmail in receiving_emails array based on matching id
    const index = this.entity.receiving_emails.findIndex(email => email.id === selectedEmail.id);
    
    // If index is found (i.e., selectedEmail exists in receiving_emails), remove it
    if (index !== -1) {
        this.entity.receiving_emails.splice(index, 1);
    }
	});
	
	const data = this.selectedEmails;
	
    try {
        // Iterate over selected emails and delete them
        for (const email of this.selectedEmails) {
            const apiUrl = `/client/deletereceivingemail/${email.id}`;
            await axios.delete(apiUrl);
        }

        // Filter out the selected emails from the entity's receiving_emails
        const updatedEmails = this.entity.receiving_emails.filter(
            (email) => !this.selectedEmails.some(selectedEmail => selectedEmail.id === email.id)
        );

        // Wait for the next DOM update before emitting the event
        await this.$nextTick();

        // Emit event to notify about the deletion and pass the updated emails
        this.$emit("Receiving_emails", updatedEmails);

        // Show notification for successful deletion
        this.$nextTick(() => {
            this.$store.dispatch('notify', {
                variant: 'success',
                title: 'Emails Deleted!',
                message: 'Selected emails deleted successfully.',
            });
        });

        // Log success message
      
    } catch (error) {
        // Handle error
        console.error('Error deleting emails:', error);

        // Show notification for deletion error
        this.$nextTick(() => {
            this.$store.dispatch('notify', {
                variant: 'danger',
                title: 'Error Deleting Emails',
                message: 'An error occurred while deleting emails.',
            });
        });
    } finally {
        // Close the delete popup or perform any other actions
        this.closeDeletePopup();
		const responseOutgoingData = await axios.post('/client/receivingEmails', {data:data , fetch:false , add:false , edit:false , delete:true});

    }

    // Update the receiving_emails array with the updatedEmails
    // this.entity.receiving_emails = updatedEmails;

    // Reset selectedEmails array
    this.selectedEmails = [];
},

		processAdditionalTaxonomies(jsonString) {
			// Check if jsonString is null or undefined
			if (jsonString === null || jsonString === undefined || jsonString === "NONE") {
			return '';  // or any default value you prefer
			}

			// Parse the JSON string into an array
			const taxonomiesArray = JSON.parse(jsonString);

			// Check if taxonomiesArray is an array
			if (!Array.isArray(taxonomiesArray)) {
			return '';  // or any default value you prefer
			}

			// Join the array elements into a string without quotes
			const formattedTaxonomies = taxonomiesArray.join(', ');

			return formattedTaxonomies;
		},
		async filterChains() {
			const searchTerm = this.entity.chain_name?.trim().toLowerCase() || '';

			if (!searchTerm) {
			this.filteredChains = [];
			return;
			}

			this.isLoading = true;
			try {
			const response = await axios.get('/client/getChains', {
				params: { page: 1, perPage: 20, search: searchTerm },
			});

				this.filteredChains = response.data.data || [];
			} catch (error) {
			console.error('Error fetching chains:', error);
			this.filteredChains = [];
			} finally {
			this.isLoading = false;
			}
		},
		selectChain(chain) {

			this.searchChain = chain.chain_name;
			this.entity.chain_name = chain.chain_name;
        	this.filteredChains = [];
			},

	filterServices() {
			// Implement the logic to filter services based on the search term
			const searchTerm = this.searchQuery ? this.searchQuery.toLowerCase() : '';
			

			// Filter services, excluding the ones already selected
			this.filteredServices = this.services.filter((service) =>
			service.name.toLowerCase().includes(searchTerm) &&
			!this.selectedServices.some(selected => selected.id === service.id) &&
			!this.filteredServices.some(filtered => filtered.id === service.id)
    		);
		

			},
		
	async selectService(selectedService) {
			
			if (!this.selectedServices.some(service => service.id === selectedService.id)) {
			
				// Push the selected facility to the array
				this.selectedServices.push(selectedService);

				
				
				this.entity.services.push(selectedService);
				
			}
			const facilityId = this.entity.id;

			try {
			const url = "/client/api/serviceList";
			const response = await axios.get(url, {
				headers: {
				"Accept": "application/json",
				},
			});

		

			response.data.facilityservices.forEach((item, index) => {
    		

			if (item.facility_id == facilityId) {
				

				response.data.services.forEach((i, index) => {
					
					if (i.id == item.service_id) {
						
						// Check if the service is not already in selectedServices before pushing
						if (!this.selectedServices.some(service => service.id === i.id)) {
							this.selectedServices.push(i);
							
                }
					}
				});
			}
		});

		
			} catch (error) {
			console.error("Error fetching services:", error);
			}

			// Clear the search term and filtered services
			this.searchQuery = '';
			
			// Update the filtered services, excluding all selected services
			this.filteredServices = this.filteredServices.filter(service => !this.selectedServices.some(selected => selected.id === service.id));

			},

		
		deselectService(selectedService) {
			// Remove the selected facility from the array
			this.selectedServices = this.selectedServices.filter(service => service.id !== selectedService.id);
		},
		
		getValidationState,
		async getServices() {
			await this.$store.dispatch("services/getAll");
			//  this.availableServices = this.services; // Initialize availableServices with all services
		},
		
		async getChains() {
			
			// await this.$store.dispatch("chains/get");
			await axios.get('/client/getChains')
			.then(response => {
				
			// response data stored in records attribute to render as list
			records.value = response.data;
			})
			.catch(error => {
				console.error(error);
			})
			.finally(() => {
				this.saving = false;
			});
		
			
			},

		cancel() {
			this.$emit("cancel");
		},
		async npiLookup() {
			try {
				this.npiLookingUp = true;

				const response = await this.$store.dispatch("facilities/npiLookup", {
					name: this.entity.name,
				});

				this.npiResults = response;
				this.npiSearched = true;
			} finally {
				this.npiLookingUp = false;
			}
		},
		async refresh() {
			try {
				this.loading = true;

				const response = await this.$store.dispatch("facilities/get", {
					id: this.id,
				});

				this.entity = response;
				// this.entity.services = {
				// 	_ids: response.services.map((service) => service.id),
				// };
				this.service_ids = response.services.map((service) => service.id);
				this.$emit("loaded", response);
			} catch (e) {
				this.$store.dispatch("apiError", {
					error: e,
					message: "Error getting facility details",
				});
			} finally {
				this.loading = false;
				this.initialLoaded = true;
			}
		},
		
		async save() {
		
			try{
				
					// let responserec = await axios.post('/client/editFacilitiesReceivingMethod', {emails:this.entity.receiving_emails , faxes:this.entity.receiving_faxes , id:this.entity.id});
					const response = await axios.post('/client/receivingEmails', {emails:this.entity.receiving_emails , faxes:this.entity.receiving_faxes , id:this.entity.id , edit:true , add:false , fetch:false , delete:false});
					
			}catch(err){
					
			}
			try {
				this.saving = true;
				const response = await this.$store.dispatch("facilities/save", this.entity);
				this.$emit("saved", response);
				this.$emit("update:id", response.id);

				// this.$store.dispatch("facilities/getAll");
				// this.$store.dispatch("facilities/getActive");
				try{
				const responsed = await axios.post('/client/facilityAddForms/edit', this.forms);
        		
				}
				catch(err){
					
				}
				// for saving contract details
				try{
					this.saveContract()
				}
				catch(err){
					
				}
				try{
					const response = await axios.post('/client/contractpricingschedule/edit', {first:this.rates , second:this.rates2 ,id:this.entity.id});
				}
				catch(err){
					
				}
				// try{
				// 	console.log("Making Request for saving emails & faxes");
				// 	let responserec = await axios.post('/client/editFacilitiesReceivingMethod', {emails:this.entity.receiving_emails , faxes:this.entity.receiving_faxes , id:this.entity.id});
				// 	console.log("REQUEST EDIT FORM =", responserec);
				// }catch(err){
				// 	console.log('An error occured while saving the receiving emails data: ', err);
				// }
			} catch (e) {
				if (e.response.data.errors) {
					this.$refs.observer.setErrors(formatErrors(e.response.data.errors));
				}

				this.$store.dispatch("apiError", {
					error: e,
					title: "Save Failed",
					message: "Error saving facility details. Please check for errors.",
					variant: "warning",
				});
			} finally {
				this.saving = false;
			}
		},
		selectedNpiResult(result) {
			if (!result) {
				this.$store.dispatch("apiError", {
					error: e,
					title: "Invalid NPI Result",
					message: "Sorry, there was an issue copying NPI details. Please enter manually.",
					variant: "warning",
					data: result,
				});
				return;
			}


			this.entity.name = result.name;
			this.entity.npi_number = result.number ?? "";
			this.entity.npi_manual = false;
			this.entity.othername=result.other_names.length > 0 ? `${result.other_names[0].organization_name ?? ""}`: "NONE";
			this.entity.organizational_subpart= result.organizational_subpart;

			const locationAddress = result.addresses.find((address) => address.address_purpose == "LOCATION");
			if (locationAddress) {
				// Contact
				this.entity.phone = locationAddress.telephone_number ?? "";
				this.entity.fax = locationAddress.fax_number ?? "";
				// Address
				this.entity.address_1 = locationAddress.address_1 ?? "";
				this.entity.address_2 = locationAddress.address_2 ?? "";
				this.entity.city = locationAddress.city ?? "";
				this.entity.state = locationAddress.state ?? "";
				this.entity.zip = locationAddress.postal_code ?? "";
			} else {
				console.warn("Unable to parse location address", locationAddress);
			}

			const primaryTaxonomy = result.taxonomies.find((taxonomy) => taxonomy.primary == true);
			if (primaryTaxonomy) {
				this.entity.primary_taxonomy = primaryTaxonomy.code ?? "";
			} else {
				console.warn("Unable to parse primary taxonomy", primaryTaxonomy);
			}

			this.npiResults = [];
			this.npiSearched = false;
		},
		createNewForm() {
			const newForm = {
			
			f_name: null,
			l_name: null,
			title_id: null,
			contact_id: null,
			phone_no: null,
			facility_name:this.entity.name
			// ... other form fields ...
			
			// ... other form-specific data ...
			};
			// Push an empty object to the forms array
			this.forms.push(newForm);
		
        },
		async TitleShow (){
			try {
					const url = "/client/facilityTitle";
						
						const response = await axios.get(url, {
						headers: {
							"Accept": "application/json",
							// You can add other headers here if needed
						},
						
						});
						
					
					if (response.data && Array.isArray(response.data)) {
							for (let i = 0; i < response.data.length; i++) {
							this.titlename.push(response.data[i].title);
							}
						}
						
				}catch (error) {
					console.error("Error fetching data:", error.message);
					}
		},
		
		async fetchContactTypes(){
				try
					{
						const url = "/client/facilityTitle";
							
							const response = await axios.get(url, {
							headers: {
								"Accept": "application/json",
								// You can add other headers here if needed
							},
							});
							if (response.data && Array.isArray(response.data)) {
								for (let i = 0; i < response.data.length; i++) {
								this.contactTypes.push(response.data[i].contact_type);
								}
							}
							
					}
				catch (error) 
				{
					console.error("Error fetching data:", error.message);
				}
			},
	
		async listFacilityContacts(){
			try
						{
							const url = "/client/facilityContactList";
								
							const data = {id:this.entity.id}
							const response = await axios.post(url,data );
								if (response.data && Array.isArray(response.data)) {
									response.data.forEach((item)=>{
										// if(item.facility_id == this.entity.id){
										// 	this.forms.push(item);
										// }
										this.forms.push(item);

									});
								}
						
						}
					catch (error) 
					{
						console.error("Error fetching data:", error.message);
					}
		},
		async fetchFacilityStatus(){
			try
						{
							const url = "/client/facilitystatuslist";
								
								const response = await axios.get(url, {
								headers: {
									"Accept": "application/json",
									// You can add other headers here if needed
								},
								});
								
							
							response.data.forEach((item)=>{
								this.facilityStatus.push(item.status);
							});
						
						}
					catch (error) 
					{
						console.error("Error fetching data:", error.message);
					}
		},
		async fetchFacilityBillType(){
			try
						{
							const url = "/client/facilitybilltypelist";
								
								const response = await axios.get(url, {
								headers: {
									"Accept": "application/json",
									// You can add other headers here if needed
								},
								});
								
							
							response.data.forEach((item)=>{
								this.billTypeOptions.push(item.bill_type);
							});
							
						}
					catch (error) 
					{
						console.error("Error fetching data:", error.message);
					}
		},
		async listFacilityContracts(){
			try
						{
							const url = "/client/facilitiescontracts/list";
						
							const data = {id:this.entity.id}
							const response = await axios.post(url,data );
							
							
							this.fullownershipTypes.forEach((item)=>{
								
								if(response.data.ownership_type_id == item.id){
									
								this.contractDetails.ownership_type = item.id;
							
							}
							});
							
							this.fullcontractBillTypes.forEach((item)=>{
								
								if(response.data.contract_bill_type_id == item.id){
								this.contractDetails.contract_bill_type = item.id;
							
								
							}
							});
							this.fullcontractTypes.forEach((item)=>{
								
								if(response.data.contract_type_id == item.id){
								this.contractDetails.contract_type = item.name;
							
							}
							});
							try{
								this.fullserviceOperationsOptions.forEach((item)=>{
									
									if(response.data.service_operation_id == item.id){
									this.contractDetails.serviceOperation = item.name;
									
									
								}
								});
							}
							catch(err){
							
							}
							
							this.contractDetails.original_start_date = response.data.original_start_date;
							this.contractDetails.term_date = response.data.term_date;
							this.contractDetails.contract_status = parseInt(response.data.status, 10);
							this.contractDetails.contract_start_date = response.data.contract_effective_date;
							this.contractDetails.contract_end_date =  response.data.expiration_date;
							this.contractDetails.renewal_date = response.data.renewal_date;
							// this.contractDetails.contract_type = response.data.contract_type_id;
							this.contractDetails.indemnification_days = response.data.indemnification_days ? response.data.indemnification_days : 10;
							this.contractDetails.max_return_work_days = response.data.max_return_days;
							this.contractDetails.contract_bill_type = response.data.max_return_days;
							console.log("response = ", response.data);
							// this.contractDetails.serviceOperation = response.data.service_operation_id; 
						}
					catch (error) 
					{
						console.error("Error fetching data:", error.message);
					}
		},
		async listDefaultContractPricingSchedules(){
			try{
				const url = "/client/api/fetchContractPricingDefaultValues";
				const response = await axios.get(url, {
								headers: {
									"Accept": "application/json",
									// You can add other headers here if needed
								},
								});
				
				if (response.data && Array.isArray(response.data)) {
					response.data.forEach((item) => {
						if (item.id < 7) {
							this.$set(this.rates, item.id-1, item.default_value); // Trigger reactivity
						} else {
							this.$set(this.rates2, item.id - 6, item.default_value); // Trigger reactivity
						}
					});

				}
				this.listContractPricingSchedules();
			}
			catch(e){
				
			}
		},
		async listContractPricingSchedules() {
			try {
				const url = "/client/contractpricingschedule/list";
				const data = { id: this.entity.id };
				const response = await axios.post(url, data);
				
				if (response.data && Array.isArray(response.data)) {
					response.data.forEach((item) => {
						// if (item.insurance_type_id < 7) {
						// 	this.rates[item.insurance_type_id] = item.contract_rate;
						// }
						// else{
						// 	this.rates2[item.insurance_type_id-6] = item.contract_rate;
						// }
						if (item.insurance_type_id < 7) {
                    // Convert decimal to percentage
                    const percentageRate = parseFloat(item.contract_rate) * 1;
                    this.rates[item.insurance_type_id] = percentageRate.toFixed(2);
                } else {
                    // Convert decimal to percentage
                    const percentageRate2 = parseFloat(item.contract_rate) * 1;
                    this.rates2[item.insurance_type_id - 6] = percentageRate2.toFixed(2);
                }
						
					}); 
				}
			
				try{
					
					const responseOutgoingData = await axios.post('/client/receivingEmails', {id:this.entity.id , fetch:true , add:false , edit:false , delete:false});
				
					if (responseOutgoingData.data && Array.isArray(responseOutgoingData.data)) {
						responseOutgoingData.data.forEach((item) => {
							
							if (item.receiving_email_id !== null) {
								
								try{
								this.receiving_emails.push({
									id: item.id,
									email: item.receiving_email_id,
									description: item.email_desc
									
								});
							}
							catch(e){
								
							}
							}

							if (item.receiving_fax_id !== null) {
							
								try{
								this.receiving_faxes.push({
									id: item.id,
									fax: item.receiving_fax_id,
									description: item.fax_desc
									
								});
							} catch(e){
								
							}
							}

						}); 
					

					}
					this.$set(this.entity, 'receiving_emails', [...this.receiving_emails]);
					this.$set(this.entity, 'receiving_faxes', [...this.receiving_faxes]);
					

				}
				catch (error) {
					console.error("Error fetching outgoing method data:", error.message);
				}
				
			} catch (error) {
				console.error("Error fetching data:", error.message);
			}
			
			
			

			
		},
		

},
};
</script>
<style scoped>

.small-empty-result {
    height: 50px; /* Adjust the height as needed */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .small-empty-result span {
    font-size: 12px; /* Adjust the font size as needed */
    margin-top: 5px; /* Add margin as needed */
  }

.custom-modal .modal-footer {
    display: none;
  }
.compact-card {
	margin-bottom: 0;
}

.label-value-row {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 0.2rem;
}

.label-text {
	font-weight: bold;
	display: inline-block;
	width: 150px;
	margin-right: 10px;
}

.text {
	color: #101111d8;
}
</style>

